import { render, staticRenderFns } from "./bulletin-manage.vue?vue&type=template&id=4a09319a&scoped=true"
import script from "./bulletin-manage.vue?vue&type=script&lang=ts"
export * from "./bulletin-manage.vue?vue&type=script&lang=ts"
import style0 from "./bulletin-manage.vue?vue&type=style&index=0&id=4a09319a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a09319a",
  null
  
)

export default component.exports